// Toasts. Errors show the server's message; undo actions sit on the toast itself.
import { toast } from 'sonner';

export function notify(message: string, opts: { undo?: () => unknown; kind?: 'success' | 'warning' | 'error'; duration?: number } = {}) {
  const fn = opts.kind === 'warning' ? toast.warning : opts.kind === 'error' ? toast.error : toast.success;
  fn(message, {
    duration: opts.duration ?? (opts.undo ? 6000 : 3200),
    action: opts.undo ? { label: 'Undo', onClick: () => void opts.undo!() } : undefined,
  });
}

export function notifyError(e: unknown) {
  toast.error(e instanceof Error ? e.message : String(e));
}

/** Run an async action, reporting failures as a toast. Returns undefined on failure. */
export async function attempt<T>(fn: () => Promise<T>, okMessage?: string): Promise<T | undefined> {
  try {
    const r = await fn();
    if (okMessage) notify(okMessage);
    return r;
  } catch (e) {
    notifyError(e);
    return undefined;
  }
}
